var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInformation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.9987 14.6663C11.6806 14.6663 14.6654 11.6816 14.6654 7.99967C14.6654 4.31778 11.6806 1.33301 7.9987 1.33301C4.3168 1.33301 1.33203 4.31778 1.33203 7.99967C1.33203 11.6816 4.3168 14.6663 7.9987 14.6663Z",
    stroke: "#A3A2A2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.28355 4.03613C7.98938 4.13185 7.70632 4.39928 7.62234 4.6608C7.52405 4.96697 7.63849 5.36426 7.88814 5.58344C8.43848 6.06665 9.36413 5.86002 9.58156 5.20538C9.77723 4.61631 9.32802 4.02955 8.65995 4.00153C8.51125 3.9953 8.36885 4.00838 8.28355 4.03613ZM7.24813 6.71762C7.03389 6.75545 6.17823 7.0485 6.13239 7.09975C6.09713 7.13917 5.98359 7.5292 6.002 7.54764C6.00773 7.55337 6.10342 7.52948 6.21461 7.4946C6.6511 7.35758 7.05813 7.42108 7.16377 7.64264C7.27603 7.87801 7.22164 8.20557 6.87235 9.39833C6.60251 10.3198 6.55554 10.5385 6.55065 10.8953C6.54749 11.1258 6.5598 11.2068 6.61822 11.3404C6.71047 11.5511 6.9392 11.7644 7.20777 11.89C7.39705 11.9786 7.45385 11.9896 7.78341 12.0014C8.22237 12.017 8.43078 11.9766 9.01569 11.7626L9.42274 11.6137L9.48321 11.4037C9.51646 11.2882 9.53625 11.1862 9.52723 11.1772C9.51818 11.1682 9.4487 11.184 9.37283 11.2125C9.16987 11.2885 8.64308 11.2899 8.50549 11.2147C8.17856 11.0362 8.1987 10.7351 8.63832 9.2289C8.91311 8.28735 8.9375 8.17231 8.94038 7.80499C8.94445 7.2834 8.7754 7.01305 8.31117 6.79888C8.13022 6.7154 8.06941 6.704 7.76321 6.69624C7.57377 6.69141 7.342 6.70106 7.24813 6.71762Z",
    fill: "#A3A2A2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/information.ed6278b76d3081dcfe86805dd23278cb.svg";
export { ForwardRef as ReactComponent };